type PublicEnv = "local" | "stage" | "production" | "test2";
export const BRANCH_ID = "62de2c4bc4f903010a3b0da0";
export const COUNTRY = "Czech Republic";
export const API_HOST = process.env.REACT_APP_API_HOST;
export const REACT_APP_PUBLIC_ENV = process.env.REACT_APP_PUBLIC_ENV;